import _initializerDefineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty.js";
import _defineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _applyDecoratedDescriptor from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor.js";
import _initializerWarningHelper from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerWarningHelper.js";
var _class, _descriptor, _descriptor2, _descriptor3, _UserMenuItemsList_brand;
function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
/* import __COLOCATED_TEMPLATE__ from './items-list.hbs'; */
import Component from "@glimmer/component";
import { tracked } from "@glimmer/tracking";
import { action } from "@ember/object";
import { service } from "@ember/service";
import DiscourseURL from "discourse/lib/url";
import TEMPLATE from "./items-list.hbs";
import { setComponentTemplate } from "@ember/component";
let UserMenuItemsList = (_class = (_UserMenuItemsList_brand = /*#__PURE__*/new WeakSet(), class UserMenuItemsList extends Component {
  constructor() {
    super(...arguments);
    _classPrivateMethodInitSpec(this, _UserMenuItemsList_brand);
    _initializerDefineProperty(this, "session", _descriptor, this);
    _initializerDefineProperty(this, "loading", _descriptor2, this);
    _initializerDefineProperty(this, "items", _descriptor3, this);
    _assertClassBrand(_UserMenuItemsList_brand, this, _load).call(this);
  }
  get itemsCacheKey() {}
  get showAllHref() {}
  get showAllTitle() {}
  get showDismiss() {
    return false;
  }
  get dismissTitle() {}
  get emptyStateComponent() {
    return "user-menu/items-list-empty-state";
  }
  get renderDismissConfirmation() {
    return false;
  }
  async fetchItems() {
    throw new Error(`the fetchItems method must be implemented in ${this.constructor.name}`);
  }
  async refreshList() {
    await _assertClassBrand(_UserMenuItemsList_brand, this, _load).call(this);
  }
  dismissButtonClick() {
    throw new Error(`dismissButtonClick must be implemented in ${this.constructor.name}.`);
  }
  showAll() {
    DiscourseURL.routeTo(this.showAllHref);
    this.args.closeUserMenu();
  }
}), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "session", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "loading", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "items", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _applyDecoratedDescriptor(_class.prototype, "dismissButtonClick", [action], Object.getOwnPropertyDescriptor(_class.prototype, "dismissButtonClick"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showAll", [action], Object.getOwnPropertyDescriptor(_class.prototype, "showAll"), _class.prototype)), _class);
async function _load() {
  const cached = _assertClassBrand(_UserMenuItemsList_brand, this, _getCachedItems).call(this);
  if (cached?.length) {
    this.items = cached;
  } else {
    this.loading = true;
  }
  try {
    const items = await this.fetchItems();
    _assertClassBrand(_UserMenuItemsList_brand, this, _setCachedItems).call(this, items);
    this.items = items;
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(`an error occurred when loading items for ${this.constructor.name}`, err);
  } finally {
    this.loading = false;
  }
}
function _getCachedItems() {
  const key = this.itemsCacheKey;
  if (key) {
    return this.session[`user-menu-items:${key}`];
  }
}
function _setCachedItems(newItems) {
  const key = this.itemsCacheKey;
  if (key) {
    this.session.set(`user-menu-items:${key}`, newItems);
  }
}
export { UserMenuItemsList as default };
setComponentTemplate(TEMPLATE, UserMenuItemsList);